import {FieldNames} from '@hconnect/tuc-processes/fields'

/**
 * Field name mapping - can be a string, FieldNames object, or an array for composite fields.
 * - String: Simple field name (e.g., 'material')
 * - FieldNames object: For fields with fieldPart (e.g., {field: 'dateTime', fieldPart: 'date'})
 * - Array: Composite fields that map to multiple form fields (e.g., ['spacingOrFlowRate', 'timeOnJobSite'])
 */
export type FieldNameMapping = FieldNames | FieldNames[]

/**
 * Maps field IDs to their corresponding FieldNames used by the changeable fields system.
 * This enables the overview to determine if fields are read-only, changed, or require approval.
 *
 * Some fields (like intervals) are composite and map to multiple form fields.
 * For composite fields, the state is combined:
 * - isReadOnly: true only if ALL fields are not changeable
 * - isChanged: true if ANY field is dirty
 * - requiresApproval: true if ANY dirty field requires dispatch confirmation
 *
 * @example
 * // Get the FieldNames for the 'material' field (single)
 * const fieldName = FIELD_ID_TO_FIELD_NAMES['material'] // {field: 'material'}
 *
 * // Get the FieldNames for the 'intervals' field (composite)
 * const fieldNames = FIELD_ID_TO_FIELD_NAMES['intervals'] // [{field: 'spacingOrFlowRate'}, {field: 'timeOnJobSite'}]
 */
export const FIELD_ID_TO_FIELD_NAMES: Record<string, FieldNameMapping> = {
  material: ['material', 'materialVariations'],
  materialVariations: 'materialVariations',
  usage: 'concreteUsage',
  quantity: [{field: 'quantity'}, 'plusLoadExpected', 'maxLoadSize'],
  intervals: ['spacingOrFlowRate', 'timeOnJobSite'],
  date: {field: 'dateTime', fieldPart: 'date'},
  time: {field: 'dateTime', fieldPart: 'time'},
  poNumber: 'poNumber',
  driverInstructions: 'driverInstructions',
  additionalNotes: 'additionalNotes',
  retarder: 'materialVariations',
  siteContact: 'siteContact',
  materialTesting: 'isTestBooked'
}
